import type { Lang } from './api';

/**
 * Язык живёт в адресе: английский — без приставки, русский и армянский —
 * под /ru и /hy. Так у каждой страницы на каждом языке свой адрес, и
 * поисковик видит три версии сайта, а не одну английскую.
 *
 * Файл без зависимостей от браузера: им же пользуется сборка, когда
 * раскладывает готовые страницы для поисковиков.
 */

export const DEFAULT_LANG: Lang = 'en';

const PREFIX = /^\/(ru|hy)(?=\/|$)/;

/** «/ru/tea/x» → язык ru и путь «/tea/x» */
export function splitLang(pathname: string): { lang: Lang; rest: string } {
  const match = PREFIX.exec(pathname);
  if (!match) return { lang: DEFAULT_LANG, rest: pathname || '/' };
  return { lang: match[1] as Lang, rest: pathname.slice(match[0].length) || '/' };
}

/** «/tea/x» на русском → «/ru/tea/x». Главная на русском — «/ru» */
export function localize(path: string, lang: Lang): string {
  if (lang === DEFAULT_LANG) return path;
  return path === '/' ? `/${lang}` : `/${lang}${path}`;
}
